import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickAccessTiles = () => {
  const quickActions = [
    {
      id: 1,
      title: "Lihat Motor",
      description: "Jelajahi koleksi motor Honda terbaru dengan berbagai pilihan tipe dan warna",
      icon: "Bike",
      iconColor: "var(--color-primary)",
      bgColor: "bg-primary/10",
      link: "/produk/motor",
      cta: "Lihat Koleksi"
    },
    {
      id: 2,
      title: "Simulasi Kredit",
      description: "Hitung cicilan motor impian Anda dengan mudah dan dapatkan penawaran terbaik",
      icon: "Calculator",
      iconColor: "var(--color-success)",
      bgColor: "bg-success/10",
      link: "/credit-simulation",
      cta: "Hitung Sekarang"
    },
    {
      id: 3,
      title: "Booking Service",
      description: "Jadwalkan service motor Anda dengan cepat dan dapatkan layanan terbaik",
      icon: "Wrench",
      iconColor: "var(--color-warning)",
      bgColor: "bg-warning/10",
      link: "/service-booking",
      cta: "Booking Sekarang"
    },
    {
      id: 4,
      title: "Suku Cadang",
      description: "Temukan suku cadang dan aksesoris original Honda untuk motor Anda",
      icon: "Package",
      iconColor: "var(--color-accent)",
      bgColor: "bg-accent/10",
      link: "/produk/suku-cadang",
      cta: "Lihat Produk"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12" data-aos="fade-up" >
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full mb-4">
            <Icon name="Zap" size={18} color="var(--color-primary)" />
            <span className="text-sm font-heading font-semibold text-primary">
              Akses Cepat
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            Layanan Kami untuk Anda
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Temukan berbagai layanan Honda Pamulang yang dirancang untuk kemudahan dan kenyamanan Anda
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {quickActions?.map((action) => (
            <div
              key={action?.id}
              data-aos={action.id <= 2 ? 'fade-right' : 'fade-left'}
              data-aos-delay={action.id * 100}
              className="group bg-card rounded-xl p-6 shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 ${action?.bgColor} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={action?.icon} size={28} color={action?.iconColor} strokeWidth={2} />
              </div>

              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground mb-2">
                {action?.title}
              </h3>

              <p className="text-sm text-muted-foreground leading-relaxed mb-4 line-clamp-3">
                {action?.description}
              </p>

              <Button
                variant="ghost"
                size="sm"
                iconName="ArrowRight"
                iconPosition="right"
                onClick={() => window.location.href = action?.link}
                className="w-full justify-between group-hover:text-white"
              >
                {action?.cta}
              </Button>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 p-6 bg-gradient-to-r from-primary/10 via-accent/10 to-primary/10 rounded-xl"
          data-aos="fade-up"
          data-aos-delay="200">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center">
                <Icon name="Headphones" size={24} color="white" />
              </div>
              <div className="text-left">
                <p className="text-sm font-heading font-semibold text-foreground">
                  Butuh Bantuan?
                </p>
                <p className="text-xs text-muted-foreground">
                  Tim kami siap membantu Anda
                </p>
              </div>
            </div>
            <Button
              variant="default"
              size="default"
              iconName="MessageCircle"
              iconPosition="left"
              onClick={() => window.open('https://wa.me/6288293642972?text=Halo, saya butuh bantuan Terkait Layanan Honda Berdikari Pamulang', '_blank')}
            >
              Chat WhatsApp
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickAccessTiles;